import { render, staticRenderFns } from "./SectionArticle.vue?vue&type=template&id=722078f8&scoped=true&"
import script from "./SectionArticle.vue?vue&type=script&lang=ts&"
export * from "./SectionArticle.vue?vue&type=script&lang=ts&"
import style0 from "./SectionArticle.vue?vue&type=style&index=0&id=722078f8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722078f8",
  null
  
)

export default component.exports